module.exports = __webpack_public_path__ + "img/Frame Logo Smartphone.ec7d6c7a.webp";